import request from '../utils/request.js';
let apiConfig = null;
try {
  apiConfig = require('../../src/config/api').default;
} catch (e) {
  // 文件不存在时忽略错误
}
const guard = process.env.VUE_APP_GUARD ?? apiConfig?.VUE_APP_GUARD;
//基于文件字节流上传
export function uploadUrl(data) {
  return request({
    baseURL: guard,
    withCredentials: true,
    url: '/guard/resource/v1/resources/url',
    method: 'post',
    data: data,
    notThirdLoginUserId: true,
    notNeedToken: true,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}